export const SHEET_DEFAULT_PADDING = '500';
export const SHEET_MAX_DESKTOP_WIDTH = '384px';
